import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch, FiArrowRight, FiCheckCircle } = FiIcons;

const QuizSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-[48px] p-8 md:p-16 shadow-2xl shadow-blue-900/5 border border-gray-100 relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full -mr-32 -mt-32 opacity-50"></div>
          
          <div className="relative z-10 grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full font-bold text-xs uppercase tracking-widest mb-6">
                <SafeIcon icon={FiSearch} /> Descubra o Ideal
              </span>
              <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                Não sabe qual banho ou tosa escolher?
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed font-medium">
                Criamos um <b>Quiz Inteligente</b> para ajudar você a encontrar o serviço perfeito para a raça e tipo de pelagem do seu pet, incluindo estimativa de valores.
              </p>
              
              <ul className="space-y-4 mb-10">
                <li className="flex items-center gap-3 text-gray-700 font-bold">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 w-5 h-5" /> Sugestão baseada na raça
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-bold">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 w-5 h-5" /> Estimativa de investimento
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-bold">
                  <SafeIcon icon={FiCheckCircle} className="text-green-500 w-5 h-5" /> Indicação de tratamentos específicos
                </li>
              </ul>

              <a 
                href="https://quiz.unipet.online/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-blue-900 text-white px-10 py-5 rounded-2xl font-black text-lg hover:bg-blue-950 transition-all shadow-xl shadow-blue-900/20"
              >
                Começar o Quiz agora <SafeIcon icon={FiArrowRight} />
              </a>
            </div>

            <div className="relative">
              <div className="aspect-square bg-blue-50 rounded-[40px] flex items-center justify-center border-4 border-white shadow-xl rotate-3">
                 <div className="text-center p-8">
                    <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                      <SafeIcon icon={FiSearch} className="w-10 h-10 text-blue-900" />
                    </div>
                    <p className="text-blue-900 font-black text-2xl mb-2">Quiz UniPET</p>
                    <p className="text-gray-500 font-bold">Menos de 1 minuto para descobrir o melhor para seu pet.</p>
                 </div>
              </div>
              {/* Floating tags */}
              <div className="absolute -top-4 -left-4 bg-orange-500 text-white px-6 py-3 rounded-2xl font-bold shadow-lg -rotate-6">
                100% Gratuito
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuizSection;